(() => {
if (window.lnPremiumCollectionAsset) return;
window.lnPremiumCollectionAsset = true;
const init = root => {
if (root.lnpCleanup) root.lnpCleanup();
const life = new AbortController();
const on = (target, name, fn, options = {}) => target?.addEventListener(name, fn, {...options, signal: life.signal});
const q = selector => root.querySelector(selector);
const qa = selector => [...root.querySelectorAll(selector)];
const copy = JSON.parse(q('[data-lnp-messages]').textContent);
const route = (window.Shopify?.routes?.root || root.dataset.root || '/').replace(/\/+$/, '') + '/';
const routeRoot = route;
const track = (action, extra = {}) => {const detail = {event:'ln_collection_interaction',action,collection:root.dataset.collection,...extra};root.dispatchEvent(new CustomEvent('ln:collection',{bubbles:true,detail}));if(Array.isArray(window.dataLayer))window.dataLayer.push(detail);};
const currency = root.dataset.currency || 'MXN';
const format = value => new Intl.NumberFormat(root.dataset.locale || 'es-MX', {style:'currency', currency, maximumFractionDigits: value % 100 ? 2 : 0}).format(value / 100);
const gradeOf = value => String(value || '').trim().toLowerCase().replace(/×/g, 'x').split(/[\s–—-]+/)[0];
const grades = ['5x', '6x', '10x'];
const optionsOf = product => product.options.map(option => typeof option === 'string' ? option : option.name);
const restrict = (product, fixedGrade = '') => {
product.options = optionsOf(product);
const index = product.options.findIndex(name => /^(material|calidad|quality)$/i.test(name.trim()));
product.variants = product.variants.filter(variant => grades.includes(gradeOf(index < 0 ? fixedGrade : variant.options[index])));
product.fixedGrade = fixedGrade;
return product;
};
const detailUrl = (product, variant) => {
const url = new URL(product.url, location.origin);
if (url.origin !== location.origin) return route + 'collections/all';
url.searchParams.set('view', root.dataset.view || 'premium');
if (variant) url.searchParams.set('variant', variant);
return url.pathname + url.search;
};
let opener, lock = '', controller, quickProduct, baseProduct, selected = [], adding = false;
const closeAll = () => qa('dialog[open]').forEach(dialog => dialog.close());
const show = (name, trigger = document.activeElement) => {
const dialog = q('[data-modal="' + name + '"]');
if (!dialog || dialog.open) return;
const nextFocus = trigger?.closest('dialog') ? opener : trigger;
closeAll();
opener = nextFocus;
lock = document.documentElement.style.overflow;
document.documentElement.style.overflow = 'hidden';
if (name === 'search') updateSearchViewport();
dialog.showModal();
if (name === 'menu') normalizeArrows(dialog);
syncSearchTrigger();
if (name === 'search') {searchInput.focus({preventScroll:true});updateSearchViewport();}
};
on(root, 'close', event => {
if (event.target.dataset.modal === 'search') resetSearch();
syncSearchTrigger();
if (event.target.dataset.modal === 'quick') {
controller?.abort();
quickProduct = undefined;
}
if (!q('dialog[open]')) {
document.documentElement.style.overflow = lock;
if (opener?.isConnected) opener.focus({preventScroll:true});
}
}, {capture:true});
const arrowPattern=/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?/gu;
const arrowDirection=char=>({ '←':'left','‹':'left','«':'left','❮':'left','↑':'up','↓':'down','↗':'up-right','↘':'down-right','↖':'up-left','↙':'down-left' }[char]||'right');
const arrowPaths={right:'M4 12h15m-6-6 6 6-6 6',left:'M20 12H5m6-6-6 6 6 6',up:'M12 20V5m-6 6 6-6 6 6',down:'M12 4v15m-6-6 6 6 6-6','up-right':'M5 19 19 5M7 5h12v12','down-right':'M5 5l14 14M7 19h12V7','up-left':'M19 19 5 5m0 12V5h12','down-left':'M19 5 5 19m0-12v12h12'};
const makeArrow=character=>{
const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
for(const [name,value] of Object.entries({class:'lnw-arrow lnw-text-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
path.setAttribute('d',arrowPaths[arrowDirection(character[0])]);path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);return svg;
};
const normalizeArrows=(menu=root)=>{
if(!menu)return;
menu.querySelectorAll('svg').forEach(svg=>{
const paths=[...svg.querySelectorAll('path')];
if(paths.length!==1||!/^(?:m146-6666|m10666-66|m412h15m-6-666-66|m69666-6)$/i.test((paths[0].getAttribute('d')||'').replace(/[\s,]/g,'')))return;
svg.classList.add('lnw-arrow');
for(const [name,value] of Object.entries({fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round'}))svg.setAttribute(name,value);
paths[0].setAttribute('fill','none');paths[0].setAttribute('stroke','currentColor');
});
const walker=document.createTreeWalker(menu,NodeFilter.SHOW_TEXT),nodes=[];let node;
while(node=walker.nextNode()){const parent=node.parentElement;if(parent?.closest('a,button,summary')&&!parent.closest('svg,script,style')&&/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮]/u.test(node.data))nodes.push(node)}
nodes.forEach(text=>{const fragment=document.createDocumentFragment();let position=0;for(const match of text.data.matchAll(arrowPattern)){fragment.append(document.createTextNode(text.data.slice(position,match.index)),makeArrow(match[0]));position=match.index+match[0].length}fragment.append(document.createTextNode(text.data.slice(position)));text.replaceWith(fragment)});
menu.querySelectorAll('a,button,summary,a span,button span,summary span').forEach(element=>{
if(element.closest('svg'))return;
for(const side of ['before','after']){
if(element.hasAttribute('data-ln-arrow-'+side))continue;
let content='';try{content=getComputedStyle(element,'::'+side).content||''}catch{}
const text=content.replace(/^["']|["']$/g,'').trim();
if(!/^[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?$/u.test(text))continue;
element.setAttribute('data-ln-arrow-'+side,'');const svg=makeArrow(text);if(side==='before')element.prepend(svg);else element.append(svg);
}
});
};
on(q('[data-modal="menu"]'),'toggle',()=>normalizeArrows(q('[data-modal="menu"]')),{capture:true});

const searchDialog = q('dialog[data-modal="search"]');
const searchInput = q('[data-search-input]');
const searchResults = q('[data-search-results]');
const searchStatus = q('[data-search-status]');
const searchAll = q('[data-search-all]');
const searchHints = q('[data-search-hints]');
const searchViewport = window.visualViewport;
const syncSearchTrigger = () => qa('[data-dialog="search"][aria-expanded]').forEach(trigger=>trigger.setAttribute('aria-expanded',String(Boolean(searchDialog?.open))));
const updateSearchViewport = () => {
if(!searchDialog)return;
const height=searchViewport?.height || window.innerHeight,width=searchViewport?.width || window.innerWidth;
searchDialog.style.setProperty('--lnw-visual-height',height+'px');
searchDialog.style.setProperty('--lnw-visual-width',width+'px');
searchDialog.style.setProperty('--lnw-visual-top',Math.max(0,searchViewport?.offsetTop || 0)+'px');
searchDialog.style.setProperty('--lnw-visual-left',Math.max(0,searchViewport?.offsetLeft || 0)+'px');
searchDialog.classList.toggle('is-short',height<300);
};
on(searchViewport,'resize',updateSearchViewport,{passive:true});
on(searchViewport,'scroll',updateSearchViewport,{passive:true});
on(window,'resize',updateSearchViewport,{passive:true});
updateSearchViewport();
const setSearchAllLabel = term => {
const label=document.createElement('span'),svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
label.textContent=searchAll.dataset.label+' “'+term+'”';
for(const [name,value] of Object.entries({class:'lnw-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
path.setAttribute('d','M4 12h15m-6-6 6 6-6 6');path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);searchAll.replaceChildren(label,svg);
};
on(searchInput.closest('form'),'submit',event=>{searchInput.value=searchInput.value.trim();if(!searchInput.value){event.preventDefault();searchInput.focus({preventScroll:true});return}track('search_submit');});
const searchCopy = (root.dataset.locale || 'es').startsWith('en') ?
{loading:'Searching…',empty:'No matching products. Try another name, color or size.',error:'Suggestions are unavailable. Press Enter to search the store.',found:'results'} :
{loading:'Buscando…',empty:'No encontramos productos. Prueba con otro nombre, color o talla.',error:'No se cargaron las sugerencias. Presiona Enter para buscar en la tienda.',found:'resultados'};
const priceFormatter = new Intl.NumberFormat(root.dataset.locale || 'es-MX',{style:'currency',currency,maximumFractionDigits:2});
let searchTimer, searchController, searchRequest = 0, activeResult = -1;
const searchCache = new Map();
const safeLink = (url, segment) => {
try {
const target = new URL(url, location.origin);
return target.origin === location.origin && target.pathname.includes('/'+segment+'/') ? target.pathname+target.search+target.hash : null;
} catch {return null;}
};
const safeImage = url => {
try {const target = new URL(url, location.origin);return target.protocol === 'https:' ? target.href : null;}
catch {return null;}
};
const resetSearch = () => {
clearTimeout(searchTimer);searchController?.abort();searchRequest++;activeResult=-1;
searchInput.value='';searchInput.setAttribute('aria-expanded','false');searchInput.removeAttribute('aria-activedescendant');
searchResults.replaceChildren();searchResults.hidden=true;searchAll.hidden=true;searchHints.hidden=false;searchStatus.textContent='';
};
const updateSearch = (data, term) => {
searchResults.replaceChildren();activeResult=-1;searchInput.removeAttribute('aria-activedescendant');
const products = Array.isArray(data?.resources?.results?.products) ? data.resources.results.products.slice(0,6) : [];
const collections = Array.isArray(data?.resources?.results?.collections) ? data.resources.results.collections.slice(0,2) : [];
let count=0;
const group = (label) => {
const container=document.createElement('div');container.className='lnw-search-group';
const heading=document.createElement('p');heading.textContent=label;container.append(heading);
const list=document.createElement('div');list.className='lnw-search-list';list.setAttribute('role','group');list.setAttribute('aria-label',label);
container.append(list);searchResults.append(container);return list;
};
if(products.length){
const list=group(searchResults.dataset.productsLabel);
for(const product of products){
const href=safeLink(product.url,'products');if(!href)continue;
const link=document.createElement('a');link.className='lnw-search-result';link.href=href;link.dataset.searchResult='product';link.id='lnw-result-'+root.dataset.sectionId+'-'+count++;link.setAttribute('role','option');link.setAttribute('aria-selected','false');
const image=safeImage(product.image || product.featured_image?.url);
if(image){const img=document.createElement('img');img.src=image;img.alt='';img.loading='lazy';img.width=66;img.height=66;link.append(img);}
else {const placeholder=document.createElement('span');placeholder.className='lnw-search-placeholder';placeholder.setAttribute('aria-hidden','true');placeholder.textContent='LN';link.append(placeholder);}
const name=document.createElement('span');name.className='lnw-search-name';name.textContent=product.title || '';
if(product.vendor){const vendor=document.createElement('small');vendor.textContent=product.vendor;name.append(vendor);}
link.append(name);
const value=Number(product.price);
if(Number.isFinite(value) && value>=0){const price=document.createElement('span');price.className='lnw-search-price';price.textContent=priceFormatter.format(value);link.append(price);}
list.append(link);
}
}
if(collections.length){
const list=group(searchResults.dataset.collectionsLabel);
for(const collection of collections){
const href=safeLink(collection.url,'collections');if(!href)continue;
const link=document.createElement('a');link.className='lnw-search-collection';link.href=href;link.dataset.searchResult='collection';link.id='lnw-result-'+root.dataset.sectionId+'-'+count++;link.setAttribute('role','option');link.setAttribute('aria-selected','false');link.textContent=collection.title || '';list.append(link);
}
}
const visible=searchResults.querySelectorAll('[data-search-result]').length;
searchResults.hidden=!visible;searchHints.hidden=Boolean(visible);searchInput.setAttribute('aria-expanded',String(Boolean(visible)));
searchStatus.textContent=visible ? visible+' '+searchCopy.found : searchCopy.empty;
searchAll.hidden=false;setSearchAllLabel(term);
const url=new URL(searchAll.href,location.origin);url.searchParams.set('q',term);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');searchAll.href=url.href;
};
const suggest = async term => {
const id=++searchRequest;
searchController?.abort();searchController=new AbortController();
searchStatus.textContent=searchCopy.loading;
searchAll.hidden=true;searchResults.hidden=true;searchInput.setAttribute('aria-expanded','false');
try {
const key=term.toLocaleLowerCase();let data=searchCache.get(key);
if(!data){
const url=new URL(routeRoot+'search/suggest.json',location.origin);
url.searchParams.set('q',term);url.searchParams.set('resources[type]','product,collection');url.searchParams.set('resources[limit]','6');url.searchParams.set('resources[limit_scope]','each');url.searchParams.set('resources[options][unavailable_products]','hide');
const response=await fetch(url.href,{signal:searchController.signal,headers:{Accept:'application/json'}});
if(!response.ok)throw new Error('Search '+response.status);
data=await response.json();searchCache.set(key,data);
if(searchCache.size>20)searchCache.delete(searchCache.keys().next().value);
}
if(id===searchRequest && searchDialog.open && searchInput.value.trim()===term)updateSearch(data,term);
} catch(error){
if(id!==searchRequest || error.name==='AbortError')return;
searchResults.hidden=true;searchHints.hidden=false;searchInput.setAttribute('aria-expanded','false');
searchStatus.textContent=searchCopy.error;
const url=new URL(searchAll.href,location.origin);url.searchParams.set('q',term);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');searchAll.href=url.href;
setSearchAllLabel(term);searchAll.hidden=false;
}
};
on(searchInput,'input',() => {
clearTimeout(searchTimer);searchController?.abort();searchRequest++;activeResult=-1;
searchInput.removeAttribute('aria-activedescendant');
const term=searchInput.value.trim();
if(term.length<2){searchResults.replaceChildren();searchResults.hidden=true;searchHints.hidden=false;searchAll.hidden=true;searchStatus.textContent='';searchInput.setAttribute('aria-expanded','false');return;}
searchResults.hidden=true;searchHints.hidden=true;searchAll.hidden=true;searchInput.setAttribute('aria-expanded','false');
searchTimer=setTimeout(()=>suggest(term),240);
});
on(searchInput,'keydown',event => {
if(!['ArrowDown','ArrowUp','Enter'].includes(event.key) || searchResults.hidden)return;
const options=[...searchResults.querySelectorAll('[data-search-result]')];if(!options.length)return;
if(event.key==='Enter'){if(activeResult<0)return;event.preventDefault();track('search_suggestion_open',{type:options[activeResult].dataset.searchResult});location.assign(options[activeResult].href);return;}
event.preventDefault();
activeResult=event.key==='ArrowDown'?(activeResult+1)%options.length:(activeResult-1+options.length)%options.length;
for(const option of options)option.setAttribute('aria-selected',String(option===options[activeResult]));
searchInput.setAttribute('aria-activedescendant',options[activeResult].id);
const scrollArea=q('[data-search-scroll]'),area=scrollArea.getBoundingClientRect(),option=options[activeResult].getBoundingClientRect();
if(option.bottom>area.bottom)scrollArea.scrollTop+=option.bottom-area.bottom;
else if(option.top<area.top)scrollArea.scrollTop-=area.top-option.top;
});

let headerFrame = 0;
const updateHeader = () => {headerFrame=0;const fixed=window.scrollY>120;q('.lnw-head')?.classList.toggle('is-scrolled',fixed);q('.lnw-head-space')?.toggleAttribute('hidden',!fixed);};
const scheduleHeader = () => {if(!headerFrame)headerFrame=requestAnimationFrame(updateHeader);};
on(window,'scroll',scheduleHeader,{passive:true});
on(window,'resize',scheduleHeader,{passive:true});
updateHeader();
const load = async (product, signal) => {
const url = new URL(product.url, location.origin);
url.searchParams.set('view', 'lnw-quick');
const response = await fetch(url, {signal, headers:{Accept:'text/html'}});
if (!response.ok) throw new Error(copy.load_error);
const document = new DOMParser().parseFromString(await response.text(), 'text/html');
const data = document.querySelector('[data-lnw-product-full]');
if (!data) throw new Error(copy.load_error);
const productData = restrict(JSON.parse(data.textContent), product.fixedGrade || '');
productData.title = product.title;
if (!productData.variants.length) throw new Error(copy.unavailable);
return productData;
};
const currentVariant = () => quickProduct?.variants.find(variant => variant.options.every((value, index) => value === selected[index]));
const renderOptions = () => {
const container = q('[data-quick-options]');
container.replaceChildren();
const ordered = quickProduct.options.map((name,index) => ({name,index}));
ordered.sort((a,b) => Number(/^(material|calidad|quality)$/i.test(b.name)) - Number(/^(material|calidad|quality)$/i.test(a.name)));
ordered.forEach(({name,index}) => {
let values = [...new Set(quickProduct.variants.map(variant => variant.options[index]))];
if (name === 'Title' && values[0] === 'Default Title') return;
if (/^(material|calidad|quality)$/i.test(name)) values.sort((a,b) => grades.indexOf(gradeOf(a)) - grades.indexOf(gradeOf(b)));
const field = document.createElement('fieldset');
const legend = document.createElement('legend');legend.textContent = name;field.append(legend);
const list = document.createElement('div');list.className = 'lnp-option-values';
for (const value of values) {
const button = document.createElement('button');button.type = 'button';button.textContent = value;
button.dataset.option = index;button.dataset.value = value;button.setAttribute('aria-pressed', String(selected[index] === value));
if (!/^(material|calidad|quality)$/i.test(name)) button.disabled = !quickProduct.variants.some(variant => variant.options[index] === value && variant.options.every((option,i) => i === index || !selected[i] || selected[i] === option));
list.append(button);
}
field.append(list);container.append(field);
});
const variant = currentVariant();
const button = q('[data-add]');
button.disabled = !variant || adding;
button.textContent = variant ? (variant.buyable && !quickProduct.consultOnly ? copy.add : copy.consult) : copy.choose_options;
q('[data-quick-status]').textContent = variant && (!variant.buyable || quickProduct.consultOnly) ? copy.unavailable : '';
if (variant) {
q('[data-quick-price]').textContent = format(variant.price) + ' ' + currency;
q('[data-product-link]').href = detailUrl(baseProduct, variant.id);
} else {
const candidates = quickProduct.variants.filter(option => option.options.every((value,i) => !selected[i] || selected[i] === value));
const choices = candidates.filter(option => option.buyable);
const fallback = (choices.length ? choices : candidates).sort((a,b) => a.price - b.price)[0];
if (fallback) {q('[data-quick-price]').textContent = format(fallback.price) + ' ' + currency;q('[data-product-link]').href = detailUrl(baseProduct, fallback.id);}
}
};
const quick = async id => {
if (adding) return;
const data = q('[data-piece-json="' + id + '"]');if (!data) return;
controller?.abort();
baseProduct = JSON.parse(data.textContent);
q('[data-quick-title]').textContent = baseProduct.title;
q('[data-quick-price]').textContent = format(baseProduct.price) + ' ' + currency;
const image = q('[data-quick-image]');
image.hidden = !baseProduct.image;
if (baseProduct.image) {image.src = baseProduct.image;image.alt = baseProduct.title;}
q('[data-quick-options]').replaceChildren();
q('[data-cart-link]').hidden = true;
q('[data-add]').disabled = true;q('[data-add]').textContent = copy.loading;
q('[data-quick-status]').textContent = copy.loading;
q('[data-product-link]').href = detailUrl(baseProduct, baseProduct.selected);
show('quick');
const request = new AbortController();controller = request;
try {
const loaded = await load(baseProduct, request.signal);
if (request !== controller || !q('[data-modal="quick"]').open) return;
quickProduct = loaded;
const variant = loaded.variants.find(value => String(value.id) === String(baseProduct.selected)) || loaded.variants.find(value => value.buyable) || loaded.variants[0];
selected = [...variant.options];
renderOptions();
} catch (error) {
if (error.name === 'AbortError') return;
q('[data-quick-status]').textContent = error.message || copy.load_error;
q('[data-add]').textContent = copy.choose_options;
}
};
const add = async () => {
const variant = currentVariant();if (!variant || adding) return;
const productId = quickProduct.id;
if (!variant.buyable || quickProduct.consultOnly) {
const url = new URL(root.dataset.advice);
url.searchParams.set('text', copy.consult_message + ' ' + quickProduct.title + ' — ' + variant.options.join(' / '));
location.assign(url.href);return;
}
adding = true;
const button = q('[data-add]');button.disabled = true;button.textContent = copy.adding;
try {
const latest = await load(baseProduct);
const fresh = latest.variants.find(option => String(option.id) === String(variant.id));
if (!fresh || !fresh.buyable || latest.consultOnly) {
quickProduct = latest;adding = false;renderOptions();q('[data-quick-status]').textContent = copy.unavailable;return;
}
if (fresh.price !== variant.price) {
quickProduct = latest;adding = false;renderOptions();q('[data-quick-status]').textContent = copy.price_changed;return;
}
const response = await fetch(route + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items:[{id:fresh.id,quantity:1}]})});
const result = await response.json();
if (!response.ok) throw new Error(result.description || copy.add_error);
q('[data-quick-status]').textContent = copy.added;
q('[data-cart-link]').hidden = false;
const detail = {event:'ln_collection_interaction',action:'add_to_cart_success',collection:root.dataset.collection,product_id:productId,variant_id:fresh.id};
root.dispatchEvent(new CustomEvent('ln:collection', {bubbles:true,detail}));
if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
} catch (error) {q('[data-quick-status]').textContent = error.message || copy.add_error;}
finally {adding = false;if(q('[data-modal="quick"]').open){const current = currentVariant();button.disabled = !current;button.textContent = current ? (current.buyable && !quickProduct.consultOnly ? copy.add : copy.consult) : copy.choose_options;}}
};
const selectColor = swatch => {
const card = swatch.closest('[data-piece]');
if (!card || swatch.getAttribute('aria-disabled') === 'true') return;
card.querySelectorAll('[data-color-swatch]').forEach(value => value.setAttribute('aria-pressed', String(value === swatch)));
card.querySelector('[data-color-name]').textContent = swatch.dataset.color;
card.querySelector('[data-price-value]').textContent = swatch.dataset.priceLabel;
const url = new URL(swatch.href, location.origin);
url.searchParams.set('view', root.dataset.view || 'premium');
card.querySelectorAll('.lnp-card-image, h3 a').forEach(link => link.href = url.pathname + url.search);
const image = card.querySelector('.lnp-card-front');
if (image && swatch.dataset.swatchImage) {
image.src = swatch.dataset.swatchImage;
if (swatch.dataset.swatchSrcset) image.srcset = swatch.dataset.swatchSrcset;
else image.removeAttribute('srcset');
image.alt = card.querySelector('h3').textContent.trim() + ' — ' + swatch.dataset.color;
}
card.querySelector('[data-photo-note]').hidden = Boolean(swatch.dataset.swatchImage);
const script = card.querySelector('[data-piece-json]');
const product = JSON.parse(script.textContent);
product.selected = swatch.dataset.variant;
product.price = Number(swatch.dataset.price);
if (swatch.dataset.swatchImage) product.image = swatch.dataset.swatchImage;
script.textContent = JSON.stringify(product);
};
qa('[data-color-swatch][aria-pressed="true"][aria-disabled="false"]').forEach(selectColor);
on(root, 'click', event => {
const target = event.target.closest('a,button,dialog');if (!target) return;
if (target.matches('dialog') && event.target === target) {
const rect = target.getBoundingClientRect();
if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
}
if (target.matches('[data-close]')) target.closest('dialog').close();
if (target.matches('[data-open],[data-dialog]')) {event.preventDefault();show(target.dataset.open || target.dataset.dialog,target);}
if (target.matches('[data-quick]')) {event.preventDefault();quick(target.dataset.quick);}
if (target.matches('[data-add]')) add();
if (target.matches('[data-color-swatch]')) {
if (target.getAttribute('aria-disabled') === 'true') {event.preventDefault();return;}
if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {event.preventDefault();selectColor(target);}
}
if (target.matches('[data-option]') && !adding && quickProduct) {
const index = Number(target.dataset.option), value = target.dataset.value;
const next = [...selected];next[index] = value;
const candidates = quickProduct.variants.filter(variant => variant.options[index] === value);
if (!candidates.length) return;
let compatible = candidates;
next.forEach((choice,i) => {if (i === index || !choice) return;const subset = compatible.filter(variant => variant.options[i] === choice);if (subset.length) compatible = subset;else next[i] = null;});
selected = next;renderOptions();
[...q('[data-quick-options]').querySelectorAll('button')].find(button => button.dataset.option === String(index) && button.dataset.value === value)?.focus({preventScroll:true});
}
if (target.matches('a[href^="#"]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
const destination = document.getElementById(target.hash.slice(1));
if (destination) {
event.preventDefault();if(destination.tagName === 'DETAILS') destination.open = true;
destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
destination.setAttribute('tabindex','-1');destination.focus({preventScroll:true});
}
}
});
on(root, 'keydown', event => {const swatch = event.target.closest('[data-color-swatch]');if (swatch && event.key === ' ') {event.preventDefault();swatch.click();}});
on(q('[data-sort]'), 'change', event => event.target.form.requestSubmit());
root.lnpCleanup = () => {life.abort();controller?.abort();clearTimeout(searchTimer);searchController?.abort();if(headerFrame)cancelAnimationFrame(headerFrame);closeAll();document.documentElement.style.overflow = lock;};
};
document.querySelectorAll('[data-ln-premium]').forEach(init);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ln-premium]').forEach(init));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ln-premium]').forEach(root => root.lnpCleanup?.()));
})();
